import React, { useState, useEffect } from "react";
import { Button, Modal, Icon, Image, Grid } from "semantic-ui-react";
import Images from "../../../../../../CBP_App/config/images";
import InputField from "../../../../../../CBP_App/formComponents/inputField";
import DropDown from "../../../../../../commonComponents/formComponents/dropDown";
import { getDropDownInputText } from "../../../../../../C88_App/formSections/util/index";
import { fileStatementUpdateRequest ,getStatementUpdateStatusRequest } from "../../../../../../apiCalls/MainFormRequests";
import { months } from "../../../../../../CBP_App/formSections/util/constants";
import {CustomDate} from "kx-common-components";
import moment from 'moment'
import { isBusinessDay } from "../../../../../../CBP_App/formSections/util";
import { result } from "lodash";
import Draggable from 'react-draggable'
import { isBusinessDayMemoized } from "kx-common-components"
const currenMonth =[]
let month = months.find((a) => parseInt(a.id) == new Date().getUTCMonth() + 1)
.id
let nextMOnth = (parseInt(month)%12 + 1).toString()
 currenMonth.push(parseInt(month))
 currenMonth.push(parseInt(nextMOnth))
const paymentTypesDropDownValues = (defaultPaymentType1, statementPaymentTypeIsMonthly) => [
  {
    value: "Individual Payment (NOT on a Statement)",
    id: "1",
    key: "1",
  },
  {
    value: "Daily Statement (Broker/Filer)",
    id: "2",
    key: "2",
    disabled :defaultPaymentType1 === true ? true : false
  },
  {
    value: "Daily Statement (Importer - Full IOR Number)",
    id: "3",
    key: "3",
    disabled :defaultPaymentType1 === true ? true : false
  },
  {
    value: "Daily Statement (Importer - IOR Number without Suffix)",
    id: "5",
    disabled :true,
    key: "4",
  },
  {
    value: "Monthly Statement (Broker/Filer)",
    id: "6",
    key: "5",
    disabled :defaultPaymentType1 === true ? true : false
  },
  {
    value: "Monthly Statement (Importer - Full IOR Number)",
    id: "7",
    key: "6",
    disabled :defaultPaymentType1 === true ? true : false
  },
  {
    value: "Monthly Statement (Importer - IOR Number without Suffix)",
    id: "8",
    key: "7",
    disabled :true
  },
];

const monthDropDownValues = [
  {
    value: "JAN",
    id: "01",
    disabled : !currenMonth.includes(1) 
  },
  {
    value: "FEB",
    id: "02",
    disabled :  !currenMonth.includes(2) 
  },
  {
    value: "MARCH",
    id: "03",
    disabled :  !currenMonth.includes(3) 
  },
  {
    value: "APRIL",
    id: "04",
    disabled :  !currenMonth.includes(4) 
  },
  {
    value: "MAY",
    id: "05",
    disabled :  !currenMonth.includes(5) 
  },
  {
    value: "JUNE",
    id: "06",
    disabled :  !currenMonth.includes(6) 
  },
  {
    value: "JULY",
    id: "07",
    disabled :  !currenMonth.includes(7) 
  },
  {
    value: "AUG",
    id: "08",
    disabled :  !currenMonth.includes(8) 
  },
  {
    value: "SEP",
    id: "09",
    disabled :  !currenMonth.includes(9) 
  },
  {
    value: "OCT",
    id: "10",
    disabled : !currenMonth.includes(10) 
  },
  {
    value: "NOV",
    id: "11",
    disabled : !currenMonth.includes(11) 
  },
  {
    value: "DEC",
    id: "12",
    disabled :  !currenMonth.includes(12) 
  },
];


export default function UpdateStatementsModal({
  trigger,
  handleModalClose,
  updateModelOpen,
  selectedEntriesCount,
  entryNumberJson,
  statementNumber,
  filerCode,
  updateEntriesFromStatement,
  resetCheckBoxIndex,
  heading,
  defaultPaymentType1,
  statementPrintDate,
  dateAccepted,
  accepted
}) {

  const [statementDate, setStatementDate] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [statementMonth, setStatementMonth] = useState("");
  const [isUpdateClicked, setIsUpdateClicked] = useState(false);
  const [releaseDate, setReleaseDate] = useState("");
  const[monthStatement, setMonthStatement] = useState([]);
  const [printDate, setPrintDate] = useState("");
  
  
  useEffect (() => {
    console.log("irsgad1111", accepted)
  },[])
  let monthArr = {
    '01':{value:"JAN",id:"01",disabled:true},
    '02':{value:"FEB",id:"02",disabled:true},
    '03':{value:"MARCH",id:"03",disabled:true},
    '04':{value:"APRIL",id:"04",disabled:true},
    '05':{value:"MAY",id:"05",disabled:true},
    '06':{value:"JUN",id:"06",disabled:true},
    '07':{value:"JULY",id:"07",disabled:true},
    '08':{value:"AUG",id:"08",disabled:true},
    '09':{value:"SEP",id:"09",disabled:true},
    '10':{value:"OCT",id:"10",disabled:true},
    '11':{value:"NOV",id:"11",disabled:true},
    '12':{value:"DEC",id:"12",disabled:true},
  }
  
  const getValidMonthsForDropdown = (nextMonths, relDate)=>{
    // console.log("bbbbbb",nextMonths, relDate)
    // var startDate =moment(relDate).format('YYYY-MM-DD');
    // var enDate = moment().add(2, 'M').format('YYYY-MM-DD');
    // var endDate = moment(enDate);

    // var dates = [];
    // endDate.subtract(1, "month"); //Substract one month to exclude endDate itself
    // var month = moment(startDate); //clone the startDate
    // while( month < endDate ) {
    //    month.add(1, "month");
    //   //  dates.push(month.format('YYYY-MM-DD'));
    //    dates.push(month.format('MM'));
    // }

    nextMonths = nextMonths ? nextMonths : moment().add(1, 'M').format('MM');
    var noReleaseDate = relDate ? nextMonths : moment().add(2, 'M').format('MM');

    return Object.keys(monthArr).map(val=>{
         if((parseInt(nextMonths) === parseInt(val)) || (parseInt(noReleaseDate) === parseInt(val))){
      //  if(dates.includes(val)) { 
         return {...monthArr[val],disabled:false}
        }else{
             return {...monthArr[val]}
        }
    })
 }
  useEffect(() => {
if(updateModelOpen === true){
  console.log("entryNumberJsonss",entryNumberJson[0]?.paymentStatusCode?.includes("MONTHLY"))
// get data for api to default 
let len = entryNumberJson.length
let entryNumberList =[]
for(var i = 0 ; i < len ; i++){

 entryNumberList.push(entryNumberJson[i].entryNumber)
}


let getUpdateStatusPayload = {
  statementNumber :statementNumber,
  brokerCode : filerCode,
  entryNumbers : entryNumberList
}
if(defaultPaymentType1 === true){
  setPaymentType("1");

}else{
  getStatementUpdateStatusRequest(getUpdateStatusPayload).then(async (res)=>{
    console.log(res ,"response from file statement")
    if(res && res.data && res.data.eventMessage  && res.data.eventMessage.entries && res.data.eventMessage.entries.length > 0 ){
      // let month =   res.data.eventMessage.entries[0].shipmentPeriodicStatementMonth;
      let paymentType =  res.data.eventMessage.entries[0].shipmentPaymentType.split(",")[0]
      let relDate =  res.data.eventMessage.entries[0].shipmentReleaseDate;
      let nextMonth = parseInt(new CustomDate(relDate).addMonths(1).getMonth()+1);
      let month =   nextMonth;
      let shipmentStatementPrintDate = res.data.eventMessage.entries[0].shipmentStatementPrintDate
      setMonthStatement([...getValidMonthsForDropdown(nextMonth, relDate)]);
      // let date = res.data.eventMessage.entries[0].shipmentStatementPrintDate
      setStatementMonth(month==="null" ? "" : month);
      setPaymentType(paymentType==="null" ? "" : paymentType);
      setReleaseDate(relDate ==="null" ? "" : relDate)
      setPrintDate(shipmentStatementPrintDate ==="null" ? "" : shipmentStatementPrintDate)
      // setStatementDate(date==="null" ? "-999" : date);
    } else {
      let relDate = "";
      let nextMonth = "";
      setMonthStatement([...getValidMonthsForDropdown(nextMonth, relDate)]);
    }
  });
}



}

      return () => {
        setStatementDate("");
        setPaymentType("");
        setStatementMonth("");
        setIsUpdateClicked(false);
        setReleaseDate("");
        setPrintDate("");
        setMonthStatement("");
      };
    
 
  }, [updateModelOpen]);

 const dateFormatFromUTCDate =(statementDate)=>{
  var     utCCovertedVAl = new Date(parseInt(statementDate)).toUTCString()
  var dt = new Date(utCCovertedVAl)
  var  mnth = ("0" + (dt.getUTCMonth() + 1)).slice(-2)
var date = ("0" + dt.getUTCDate()).slice(-2);
 var year =    (dt.getUTCFullYear().toString()).substr(2)
 let    result =[mnth , date ,year].join("")

 return result

 }

 const convertNumberStringToDate = (number) => {
  let str = String(number);
  let conStr = str.length < 6 ? "0" + str : str;

  let numToDate = moment(conStr, "MMDDYY");
  let convertedDate = moment(numToDate).format("MM/DD/YY");
  return convertedDate;
};
 
 const getMaxDateRange =() => {
  var myCurrentDate=new Date()
  var myFutureDate=new Date(myCurrentDate);
  myFutureDate.setDate(myFutureDate.getUTCDate() + 30)

  let finalEpoc = 
    new Date(myFutureDate).getTime()

  return  finalEpoc
 }
 
 const epoch = (date) => {
  return Date.parse(date)
}

const updateButtonStatus = (accepted, dateAccepted) => {
  if(accepted === "notAccepted"){
    return false;
  }
  else if(accepted === "accepted" && moment(dateAccepted).format("MM/DD/YY") == moment().format("MM/DD/YY")){
    return false;
  }
  else{
    return true;
  }
}

// const getMinDateRange =(releaseDates) => {
//   var rlDate = epoch(releaseDates)
//   var myCurrentDate=new Date()
//   var myFutureDate=new Date(rlDate);
//   myFutureDate.setDate(myFutureDate.getUTCDate())
//   let finalEpoc =  new Date(myFutureDate).getTime()
//   console.log(finalEpoc,"min date")
//   return  finalEpoc
//  }
 
const getMinDateRange =() => {
  var myCurrentDate=new Date()
  var myFutureDate=new Date(myCurrentDate);
  myFutureDate.setDate(myFutureDate.getUTCDate())

  
  let finalEpoc =  new Date(myFutureDate).getTime()

console.log(finalEpoc,"min date")
  return  finalEpoc
 }

  const handleConfirm = async () => {
   let len = entryNumberJson.length
   let entryNumberList =[]
   for(var i = 0 ; i < len ; i++){
    entryNumberList.push(entryNumberJson[i].entryNumber)
    // entryNumberJson[i].periodicStatementMonth =  statementMonth
    // entryNumberJson[i].newStatementPrintDate =  dateFormatFromUTCDate(statementDate)
    entryNumberJson[i].paymentType =  paymentType
    if (["2","3","5" ,"6" ,"7" ,"8"].includes(paymentType)){
      entryNumberJson[i].newStatementPrintDate = !!statementDate && statementDate !== -999 ? dateFormatFromUTCDate(statementDate) : ""
    }
    
    if(["6","7","5","8"].includes(paymentType)){
      entryNumberJson[i].periodicStatementMonth =  statementMonth
     entryNumberJson[i].newStatementPrintDate = !!statementDate && statementDate !== -999 ? dateFormatFromUTCDate(statementDate)  : ""
    }
   }
    console.log(entryNumberJson,"confirm cliked");

    let eventMessage = {
      statementNumber :statementNumber,
      brokerCode : filerCode,
      entries : entryNumberJson
    }

    let getUpdateStatusPayload = {
      statementNumber :statementNumber,
      brokerCode : filerCode,
      entryNumbers : entryNumberList
    }

  fileStatementUpdateRequest(eventMessage).then((res)=>{
   console.log(res ,"response from file statement")
   getStatementUpdateStatusRequest(getUpdateStatusPayload).then(async (res)=>{
    console.log(res ,"response from file statement")
    if(res && res.data && res.data.eventMessage && res.data.eventMessage.entries && res.data.eventMessage.entries.length > 0 ){
   await updateEntriesFromStatement(entryNumberList , res ,statementNumber ,heading)
    }
   // setTimeout(()=>{
   //   this.props.searchByID(shipId)
   // }, 500)
  });

});
 
    handleModalClose();
    resetCheckBoxIndex()
    // setIsUpdateClicked(false);
  };
   
  return (
    <Modal
      style={{ width: "40%", top: "5%" }}
      trigger={trigger}
      open={updateModelOpen}
      // open={true}
      onClose={handleModalClose}
    >
      <Grid className="updateStatementGrid">
        <Grid.Row columns={3}>
          <Grid.Column width={7}></Grid.Column>
          <Grid.Column width={2}>
            {/* <img
              className={`qryFuncIcon`}
              // src={qryFuncIcon}
              alt="qry func icon"
            /> */}
          </Grid.Column>
          <Grid.Column width={6}></Grid.Column>
          <Grid.Column width={1}>
            {" "}
            <Icon
              style={{
                position: "relative",

                color: "#008B8F",
                boxSizing: "border-box",
              }}
              name="cancel"
              className="close link icon"
              onClick={() => {
                handleModalClose();
              }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            {isUpdateClicked === false && (
              <label className="updtaeStatementModalUS">{`Update actions for ${selectedEntriesCount} selected entries`}</label>
            )}
            {isUpdateClicked === true && (
              <label className="updtaeStatementModalUS">{`Do you want to transmit selected entries ?`}</label>
            )}
          </Grid.Column>
        </Grid.Row>
        {isUpdateClicked === false && (
          <Grid.Row
            columns={1}
            className="firstRowUpdateModal"
            style={{ paddingBottom: "0px" }}
          >
            <Grid.Column width={16}>
              <DropDown
                id="payment-type-dropdown"
                className="field-bg dropdown100 payment-type-updatestatement"
                label="PAYMENT TYPE"
                isLabel={true}
                placeholder="Select"
                shipmentId={"-notShipmentSpecific"}
                text={
                  getDropDownInputText(
                    paymentType,
                    paymentTypesDropDownValues(defaultPaymentType1)
                  ) || "SELECT"
                }
                onChange={(value) => {
                  setPaymentType(value);
                }}
                data={paymentTypesDropDownValues(defaultPaymentType1, entryNumberJson[0]?.paymentStatusCode?.includes("MONTHLY"))}
                disabled={isUpdateClicked === false ? false : true}
              />
            </Grid.Column>
          </Grid.Row>
        )}

        {paymentType !== "1" && isUpdateClicked === false && (
          <>
            <Grid.Row className="SecondRowUpdateModal">
              {["2", "3", "5", "6", "7", "8"].includes(paymentType) && (
                <Grid.Column
                  className={"firstCol no-field-margin textBox"}
                  style={{ paddingRight: "0px" }}
                  width={8}
                >
                  <InputField
                    id={`date`}
                    icon={<Image src={Images.calender_icon} />}
                    type={"date"}
                    shipmentId={"-notShipmentSpecific"}
                    className={"dateUpodateMOdal"}
                    label="STATEMENT PRINT DATE"
                    // minDate={getMinDateRange()}
                    maxDate={getMaxDateRange()}
                    // showToday={false}
                    filterDate={(date) => {
                      if(!date)return true;
                      return  isBusinessDayMemoized(new Date(Date.UTC(date.getFullYear(),date.getMonth(),date.getDate())))
                    }}
                    value={
                       parseInt(statementDate || 0) > 10000
                        ? new Date(
                            new Date(parseInt(statementDate)).getUTCMonth() +
                              1 +
                              "/" +
                              new Date(parseInt(statementDate)).getUTCDate() +
                              "/" +
                              new Date(parseInt(statementDate)).getUTCFullYear()
                          ).getTime()
                        : -999
                    }
                    //  isInteger={true}
                    handleFocus={(e) => {
                      e.target.select();
                    }}
                    onChange={(value) => {
                      let val;
                      if (value && !isNaN(value.getTime())) {
                        val =  Date.UTC(
                            value.getFullYear(),
                            value.getMonth(),
                            value.getDate()
                          );
                      } else {
                        val = -999;
                      }

                      setStatementDate(val);
                    }}
                    disabled={isUpdateClicked === false ? false : true}
                  />
                </Grid.Column>
              )}
              {["6", "7", "5", "8"].includes(paymentType) &&
                isUpdateClicked === false && (
                  <Grid.Column
                    width={8}
                    className="firstCol no-field-margin textBox"
                    style={{ paddingLeft: "0px" }}
                  >
                    <DropDown
                      id="payment-schedule-dropdown"
                      className="payment-schedule-updatestatement field-bg dropdown100"
                      placeholder="Select"
                      isLabel={true}
                      shipmentId={"-notShipmentSpecific"}
                      label="MONTH"
                      style={{
                        height: "42px",
                        borderBottom: "0px",
                      }}
                      text={
                        getDropDownInputText(
                          statementMonth,
                          monthStatement
                        ) || "SELECT"
                      }
                      onChange={(value) => {
                        setStatementMonth(value);
                      }}
                      data={monthStatement}
                      disabled={isUpdateClicked === false ? false : true}
                    />
                  </Grid.Column>
                )}
            </Grid.Row>
          </>
        )}
        {isUpdateClicked === true && (
       <>
             <Grid.Row>
            <Grid.Column
              width={10}
            >
              <label className="statementConfirmationModalUS">{`Payment Type `}</label>
            </Grid.Column>
            <Grid.Column
              width={4}
            >
               <label className="updtaeStatementModallabel">
                  {paymentType}
                </label>
            </Grid.Column>
            </Grid.Row>
              {["2", "3", "5", "6", "7", "8"].includes(paymentType) && (
                <Grid.Row>
            <Grid.Column
              width={10}
            >
              <label className="statementConfirmationModalUS">{`New Statement Print Date `}</label>
            </Grid.Column>
            <Grid.Column
              width={4}
            >
          {!!statementDate && statementDate !== -999 && <label className="updtaeStatementModallabel">
                    {dateFormatFromUTCDate(statementDate).substring(0, 2) +
                      "/" +
                      dateFormatFromUTCDate(statementDate).substring(2, 4) +
                      "/" +
                      dateFormatFromUTCDate(statementDate).substring(4)}
                  </label> }
            </Grid.Column>
            </Grid.Row>
      
              )}
              {["5", "6", "7", "8"].includes(paymentType) && (
                <Grid.Row>
                <Grid.Column
              width={10}
            >
                 <label className="statementConfirmationModalUS">{`New Periodic Statement Month`}</label>
            </Grid.Column>
            <Grid.Column
              width={4}
            >
           <label className="updtaeStatementModallabel">
                    {statementMonth}
                  </label>
            </Grid.Column>
            </Grid.Row>
        
              )}
              </>
        )}
        <Grid.Row>
          <Grid.Column width={3}>
            {isUpdateClicked === false && (
              <Button
                className="cnclBtnSTatementMOdal"
                onClick={() => {
                  handleModalClose();
                  // setIsUpdateClicked(false);
                }}
              >
                CANCEL
              </Button>
            )}
            {isUpdateClicked === true && (
              <Button
                className="updateBtnSTatementMOdal"
                onClick={() => {
                  setIsUpdateClicked(false);
                }}
              >
                <span className="updateBtnLabvel"> BACK</span>
              </Button>
            )}
          </Grid.Column>
          <Grid.Column id="qryFuncLeftPanel" width={3}>
            {isUpdateClicked === false && (
              <Button
                className="updateBtnSTatementMOdal"
                onClick={() => {
                  setIsUpdateClicked(true);
                }}
                disabled={updateButtonStatus(accepted, dateAccepted)}
              >
           
                <span className="updateBtnLabvel"> UPDATE</span>
              </Button>
            )}
            {isUpdateClicked === true && (
              <Button
                className="updateBtnSTatementMOdal"
                onClick={() => {
                  handleConfirm();
                }}
              >
                <span className="updateBtnLabvel"> CONFIRM</span>
              </Button>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Modal>
  );
}